var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid jobs" },
    [
      _c("loading", {
        attrs: { active: _vm.loading, "can-cancel": true },
        on: {
          "update:active": function ($event) {
            _vm.loading = $event
          },
        },
      }),
      _c("div", { staticClass: "row mt-2" }, [
        _c("div", { staticClass: "col-12 text-center mt-2" }, [
          _c("h2", [_vm._v(_vm._s(_vm.$t("jobs")))]),
        ]),
      ]),
      _c("div", { staticClass: "row mt-2" }, [
        _c("div", { staticClass: "col-12" }, [
          _vm.loading === false
            ? _c("div", { staticClass: "tab-container" }, [
                _c("ul", { staticClass: "tabs" }, [
                  _c(
                    "li",
                    {
                      class: { "tab-active": _vm.tabs.geneva.active === true },
                      on: {
                        click: function ($event) {
                          return _vm.toggleTab(_vm.tabs.geneva)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("genevaImportJob")) + " ")]
                  ),
                  _c(
                    "li",
                    {
                      class: {
                        "tab-active": _vm.tabs.portfolioReview.active === true,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.toggleTab(_vm.tabs.portfolioReview)
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("portfolioReviewImportJob")) + " "
                      ),
                    ]
                  ),
                  _c(
                    "li",
                    {
                      class: {
                        "tab-active": _vm.tabs.commercialValue.active === true,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.toggleTab(_vm.tabs.commercialValue)
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("outageCommercialValueImportJob")) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "li",
                    {
                      class: {
                        "tab-active":
                          _vm.tabs.commercialNominatedDates.active === true,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.toggleTab(
                            _vm.tabs.commercialNominatedDates
                          )
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("outageCommercialNominationDatesImportJob")
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "li",
                    {
                      class: { "tab-active": _vm.tabs.unitPi.active === true },
                      on: {
                        click: function ($event) {
                          return _vm.toggleTab(_vm.tabs.unitPi)
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("unitOperatingParametersImportJob")) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "li",
                    {
                      class: {
                        "tab-active": _vm.tabs.plantItemPi.active === true,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.toggleTab(_vm.tabs.plantItemPi)
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("plantItemOperatingParametersImportJob")
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "li",
                    {
                      class: { "tab-active": _vm.tabs.ptRisk.active === true },
                      on: {
                        click: function ($event) {
                          return _vm.toggleTab(_vm.tabs.ptRisk)
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("updateMaintenancePtRiskJob")) + " "
                      ),
                    ]
                  ),
                  _c(
                    "li",
                    {
                      class: {
                        "tab-active": _vm.tabs.piReportJob.active === true,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.toggleTab(_vm.tabs.piReportJob)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("piReportJob")) + " ")]
                  ),
                  _c(
                    "li",
                    {
                      class: {
                        "tab-active":
                          _vm.tabs.alternateLinkingJob.active === true,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.toggleTab(_vm.tabs.alternateLinkingJob)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("alternateLinkingJob")) + " ")]
                  ),
                ]),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm.tabs.geneva.active
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "row job-history-list-container" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("table", { staticClass: "table table-sm" }, [
                    _c("thead", [
                      _c("tr", { staticClass: "header-row" }, [
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("jobHistoryStartedAt"))),
                        ]),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("jobHistoryFinishedAt"))),
                        ]),
                        _c("th", [_vm._v(_vm._s(_vm.$t("jobHistoryType")))]),
                        _c("th", [_vm._v(_vm._s(_vm.$t("jobHistoryStatus")))]),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("jobHistoryParameters"))),
                        ]),
                        _c("th", [_vm._v(_vm._s(_vm.$t("jobHistoryError")))]),
                        _c("th", [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-sm btn-default float-right",
                              on: {
                                click: function ($event) {
                                  return _vm.loadGenevaImportHistory()
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("jobHistoryRefresh")) + " "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                    _c(
                      "tbody",
                      { staticClass: "job-history-list" },
                      _vm._l(_vm.genevaImportHistory, function (historyItem) {
                        return _c("tr", { staticClass: "job-history-item" }, [
                          _c("td", [_vm._v(_vm._s(historyItem.startedAt))]),
                          _c("td", [_vm._v(_vm._s(historyItem.finishedAt))]),
                          _c("td", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  historyItem.isManual
                                    ? _vm.$t("jobHistoryTypeManual")
                                    : _vm.$t("jobHistoryTypeScheduled")
                                ) +
                                " "
                            ),
                          ]),
                          _c("td", [_vm._v(_vm._s(historyItem.status))]),
                          _c("td", [_vm._v(_vm._s(historyItem.parameters))]),
                          _c("td", { attrs: { colspan: "2" } }, [
                            _vm._v(" " + _vm._s(historyItem.error) + " "),
                          ]),
                        ])
                      }),
                      0
                    ),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "row mt-3" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn btn-primary",
                      on: {
                        click: function ($event) {
                          return _vm.runGenevaImportJob()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("runGenevaImportJob")) + " ")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn btn-secondary",
                      on: {
                        click: function ($event) {
                          return _vm.downloadGenevaData()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("downloadGenevaData")) + " ")]
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm.tabs.portfolioReview.active
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "row job-history-list-container" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("table", { staticClass: "table table-sm" }, [
                    _c("thead", [
                      _c("tr", { staticClass: "header-row" }, [
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("jobHistoryStartedAt"))),
                        ]),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("jobHistoryFinishedAt"))),
                        ]),
                        _c("th", [_vm._v(_vm._s(_vm.$t("jobHistoryType")))]),
                        _c("th", [_vm._v(_vm._s(_vm.$t("jobHistoryStatus")))]),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("jobHistoryParameters"))),
                        ]),
                        _c("th", [_vm._v(_vm._s(_vm.$t("jobHistoryError")))]),
                        _c("th", [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-sm btn-default float-right",
                              on: {
                                click: function ($event) {
                                  return _vm.loadPortfolioReviewImportHistory()
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("jobHistoryRefresh")) + " "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                    _c(
                      "tbody",
                      { staticClass: "job-history-list" },
                      _vm._l(
                        _vm.portfolioReviewImportHistory,
                        function (historyItem) {
                          return _c("tr", { staticClass: "job-history-item" }, [
                            _c("td", [_vm._v(_vm._s(historyItem.startedAt))]),
                            _c("td", [_vm._v(_vm._s(historyItem.finishedAt))]),
                            _c("td", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    historyItem.isManual
                                      ? _vm.$t("jobHistoryTypeManual")
                                      : _vm.$t("jobHistoryTypeScheduled")
                                  ) +
                                  " "
                              ),
                            ]),
                            _c("td", [_vm._v(_vm._s(historyItem.status))]),
                            _c("td", [_vm._v(_vm._s(historyItem.parameters))]),
                            _c("td", { attrs: { colspan: "2" } }, [
                              _vm._v(" " + _vm._s(historyItem.error) + " "),
                            ]),
                          ])
                        }
                      ),
                      0
                    ),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "row mt-3" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      on: {
                        click: function ($event) {
                          return _vm.runPortfolioReviewImportJob()
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("runPortfolioReviewImportJob")) +
                          " "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm.tabs.commercialValue.active
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "row job-history-list-container" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("table", { staticClass: "table table-sm" }, [
                    _c("thead", [
                      _c("tr", { staticClass: "header-row" }, [
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("jobHistoryStartedAt"))),
                        ]),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("jobHistoryFinishedAt"))),
                        ]),
                        _c("th", [_vm._v(_vm._s(_vm.$t("jobHistoryType")))]),
                        _c("th", [_vm._v(_vm._s(_vm.$t("jobHistoryStatus")))]),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("jobHistoryParameters"))),
                        ]),
                        _c("th", [_vm._v(_vm._s(_vm.$t("jobHistoryError")))]),
                        _c("th", [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-sm btn-default float-right",
                              on: {
                                click: function ($event) {
                                  return _vm.loadOutageCommercialValueImportHistory()
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("jobHistoryRefresh")) + " "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                    _c(
                      "tbody",
                      { staticClass: "job-history-list" },
                      _vm._l(
                        _vm.outageCommercialValueImportHistory,
                        function (historyItem) {
                          return _c("tr", { staticClass: "job-history-item" }, [
                            _c("td", [_vm._v(_vm._s(historyItem.startedAt))]),
                            _c("td", [_vm._v(_vm._s(historyItem.finishedAt))]),
                            _c("td", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    historyItem.isManual
                                      ? _vm.$t("jobHistoryTypeManual")
                                      : _vm.$t("jobHistoryTypeScheduled")
                                  ) +
                                  " "
                              ),
                            ]),
                            _c("td", [_vm._v(_vm._s(historyItem.status))]),
                            _c("td", [_vm._v(_vm._s(historyItem.parameters))]),
                            _c("td", { attrs: { colspan: "2" } }, [
                              _vm._v(" " + _vm._s(historyItem.error) + " "),
                            ]),
                          ])
                        }
                      ),
                      0
                    ),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "row mt-3" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      on: {
                        click: function ($event) {
                          return _vm.runOutageCommercialValueImportJob()
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("runOutageCommercialValueImportJob")) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      on: {
                        click: function ($event) {
                          return _vm.downloadOutageCommercialValueData()
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("downloadOutageCommercialValueData")) +
                          " "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm.tabs.commercialNominatedDates.active
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "row job-history-list-container" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("table", { staticClass: "table table-sm" }, [
                    _c("thead", [
                      _c("tr", { staticClass: "header-row" }, [
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("jobHistoryStartedAt"))),
                        ]),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("jobHistoryFinishedAt"))),
                        ]),
                        _c("th", [_vm._v(_vm._s(_vm.$t("jobHistoryType")))]),
                        _c("th", [_vm._v(_vm._s(_vm.$t("jobHistoryStatus")))]),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("jobHistoryParameters"))),
                        ]),
                        _c("th", [_vm._v(_vm._s(_vm.$t("jobHistoryError")))]),
                        _c("th", [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-sm btn-default float-right",
                              on: {
                                click: function ($event) {
                                  return _vm.loadOutageCommercialNominationDatesImportHistory()
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("jobHistoryRefresh")) + " "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                    _c(
                      "tbody",
                      { staticClass: "job-history-list" },
                      _vm._l(
                        _vm.outageCommercialNominationDatesImportHistory,
                        function (historyItem) {
                          return _c("tr", { staticClass: "job-history-item" }, [
                            _c("td", [_vm._v(_vm._s(historyItem.startedAt))]),
                            _c("td", [_vm._v(_vm._s(historyItem.finishedAt))]),
                            _c("td", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    historyItem.isManual
                                      ? _vm.$t("jobHistoryTypeManual")
                                      : _vm.$t("jobHistoryTypeScheduled")
                                  ) +
                                  " "
                              ),
                            ]),
                            _c("td", [_vm._v(_vm._s(historyItem.status))]),
                            _c("td", [_vm._v(_vm._s(historyItem.parameters))]),
                            _c("td", { attrs: { colspan: "2" } }, [
                              _vm._v(" " + _vm._s(historyItem.error) + " "),
                            ]),
                          ])
                        }
                      ),
                      0
                    ),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "row mt-3" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      on: {
                        click: function ($event) {
                          return _vm.runOutageCommercialNominationDatesImportJob()
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "runOutageCommercialNominationDatesImportJob"
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm.tabs.unitPi.active
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "row job-history-list-container" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("table", { staticClass: "table table-sm" }, [
                    _c("thead", [
                      _c("tr", { staticClass: "header-row" }, [
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("jobHistoryStartedAt"))),
                        ]),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("jobHistoryFinishedAt"))),
                        ]),
                        _c("th", [_vm._v(_vm._s(_vm.$t("jobHistoryType")))]),
                        _c("th", [_vm._v(_vm._s(_vm.$t("jobHistoryStatus")))]),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("jobHistoryParameters"))),
                        ]),
                        _c("th", [_vm._v(_vm._s(_vm.$t("jobHistoryError")))]),
                        _c("th", [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-sm btn-default float-right",
                              on: {
                                click: function ($event) {
                                  return _vm.loadUnitOperatingParametersImportHistory()
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("jobHistoryRefresh")) + " "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                    _c(
                      "tbody",
                      { staticClass: "job-history-list" },
                      _vm._l(
                        _vm.unitOperatingParametersImportHistory,
                        function (historyItem) {
                          return _c("tr", { staticClass: "job-history-item" }, [
                            _c("td", [_vm._v(_vm._s(historyItem.startedAt))]),
                            _c("td", [_vm._v(_vm._s(historyItem.finishedAt))]),
                            _c("td", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    historyItem.isManual
                                      ? _vm.$t("jobHistoryTypeManual")
                                      : _vm.$t("jobHistoryTypeScheduled")
                                  ) +
                                  " "
                              ),
                            ]),
                            _c("td", [_vm._v(_vm._s(historyItem.status))]),
                            _c("td", [_vm._v(_vm._s(historyItem.parameters))]),
                            _c("td", { attrs: { colspan: "2" } }, [
                              _vm._v(" " + _vm._s(historyItem.error) + " "),
                            ]),
                          ])
                        }
                      ),
                      0
                    ),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "row mt-3" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      on: {
                        click: function ($event) {
                          return _vm.runUnitOperatingParametersImportJob()
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("runUnitOperatingParametersImportJob")
                          ) +
                          " "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm.tabs.plantItemPi.active
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "row job-history-list-container" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("table", { staticClass: "table table-sm" }, [
                    _c("thead", [
                      _c("tr", { staticClass: "header-row" }, [
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("jobHistoryStartedAt"))),
                        ]),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("jobHistoryFinishedAt"))),
                        ]),
                        _c("th", [_vm._v(_vm._s(_vm.$t("jobHistoryType")))]),
                        _c("th", [_vm._v(_vm._s(_vm.$t("jobHistoryStatus")))]),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("jobHistoryParameters"))),
                        ]),
                        _c("th", [_vm._v(_vm._s(_vm.$t("jobHistoryError")))]),
                        _c("th", [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-sm btn-default float-right",
                              on: {
                                click: function ($event) {
                                  return _vm.loadPlantItemOperatingParametersImportHistory()
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("jobHistoryRefresh")) + " "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                    _c(
                      "tbody",
                      { staticClass: "job-history-list" },
                      _vm._l(
                        _vm.plantItemOperatingParametersImportHistory,
                        function (historyItem) {
                          return _c("tr", { staticClass: "job-history-item" }, [
                            _c("td", [_vm._v(_vm._s(historyItem.startedAt))]),
                            _c("td", [_vm._v(_vm._s(historyItem.finishedAt))]),
                            _c("td", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    historyItem.isManual
                                      ? _vm.$t("jobHistoryTypeManual")
                                      : _vm.$t("jobHistoryTypeScheduled")
                                  ) +
                                  " "
                              ),
                            ]),
                            _c("td", [_vm._v(_vm._s(historyItem.status))]),
                            _c("td", [_vm._v(_vm._s(historyItem.parameters))]),
                            _c("td", { attrs: { colspan: "2" } }, [
                              _vm._v(" " + _vm._s(historyItem.error) + " "),
                            ]),
                          ])
                        }
                      ),
                      0
                    ),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "row mt-3" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      on: {
                        click: function ($event) {
                          return _vm.runPlantItemOperatingParametersImportJob()
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("runPlantItemOperatingParametersImportJob")
                          ) +
                          " "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm.tabs.ptRisk.active
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "row job-history-list-container" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("table", { staticClass: "table table-sm" }, [
                    _c("thead", [
                      _c("tr", { staticClass: "header-row" }, [
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("jobHistoryStartedAt"))),
                        ]),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("jobHistoryFinishedAt"))),
                        ]),
                        _c("th", [_vm._v(_vm._s(_vm.$t("jobHistoryType")))]),
                        _c("th", [_vm._v(_vm._s(_vm.$t("jobHistoryStatus")))]),
                        _c("th", [_vm._v(_vm._s(_vm.$t("jobHistoryError")))]),
                        _c("th", [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-sm btn-default float-right",
                              on: {
                                click: function ($event) {
                                  return _vm.loadUpdateMaintenancePtRiskJobHistory()
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("jobHistoryRefresh")) + " "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                    _c(
                      "tbody",
                      { staticClass: "job-history-list" },
                      _vm._l(
                        _vm.updateMaintenancePtRiskJobHistory,
                        function (historyItem) {
                          return _c("tr", { staticClass: "job-history-item" }, [
                            _c("td", [_vm._v(_vm._s(historyItem.startedAt))]),
                            _c("td", [_vm._v(_vm._s(historyItem.finishedAt))]),
                            _c("td", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    historyItem.isManual
                                      ? _vm.$t("jobHistoryTypeManual")
                                      : _vm.$t("jobHistoryTypeScheduled")
                                  ) +
                                  " "
                              ),
                            ]),
                            _c("td", [_vm._v(_vm._s(historyItem.status))]),
                            _c("td", { attrs: { colspan: "2" } }, [
                              _vm._v(" " + _vm._s(historyItem.error) + " "),
                            ]),
                          ])
                        }
                      ),
                      0
                    ),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "row mt-3" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      on: {
                        click: function ($event) {
                          return _vm.runUpdateMaintenancePtRiskJob()
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("runUpdateMaintenancePtRiskJob")) +
                          " "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm.tabs.piReportJob.active
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "row job-history-list-container" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("table", { staticClass: "table table-sm" }, [
                    _c("thead", [
                      _c("tr", { staticClass: "header-row" }, [
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("jobHistoryStartedAt"))),
                        ]),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("jobHistoryFinishedAt"))),
                        ]),
                        _c("th", [_vm._v(_vm._s(_vm.$t("jobHistoryType")))]),
                        _c("th", [_vm._v(_vm._s(_vm.$t("jobHistoryStatus")))]),
                        _c("th", [_vm._v(_vm._s(_vm.$t("jobHistoryError")))]),
                        _c("th", [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-sm btn-default float-right",
                              on: {
                                click: function ($event) {
                                  return _vm.loadPiReportJobHistory()
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("jobHistoryRefresh")) + " "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                    _c(
                      "tbody",
                      { staticClass: "job-history-list" },
                      _vm._l(_vm.piReportJobHistory, function (historyItem) {
                        return _c("tr", { staticClass: "job-history-item" }, [
                          _c("td", [_vm._v(_vm._s(historyItem.startedAt))]),
                          _c("td", [_vm._v(_vm._s(historyItem.finishedAt))]),
                          _c("td", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  historyItem.isManual
                                    ? _vm.$t("jobHistoryTypeManual")
                                    : _vm.$t("jobHistoryTypeScheduled")
                                ) +
                                " "
                            ),
                          ]),
                          _c("td", [_vm._v(_vm._s(historyItem.status))]),
                          _c("td", { attrs: { colspan: "2" } }, [
                            _vm._v(" " + _vm._s(historyItem.error) + " "),
                          ]),
                        ])
                      }),
                      0
                    ),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "row mt-3" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      on: {
                        click: function ($event) {
                          return _vm.runPiReportJob()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("runPiReportJob")) + " ")]
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm.tabs.alternateLinkingJob.active
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "row job-history-list-container" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("table", { staticClass: "table table-sm" }, [
                    _c("thead", [
                      _c("tr", { staticClass: "header-row" }, [
                        _c("th"),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("jobHistoryStartedAt"))),
                        ]),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("jobHistoryFinishedAt"))),
                        ]),
                        _c("th", [_vm._v(_vm._s(_vm.$t("jobHistoryType")))]),
                        _c("th", [_vm._v(_vm._s(_vm.$t("jobHistoryStatus")))]),
                        _c("th", [_vm._v(_vm._s(_vm.$t("jobHistoryError")))]),
                        _c("th", [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-sm btn-default float-right",
                              on: {
                                click: function ($event) {
                                  return _vm.loadAlternateLinkingJobHistory()
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("jobHistoryRefresh")) + " "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                    _c(
                      "tbody",
                      { staticClass: "job-history-list" },
                      [
                        _vm._l(
                          _vm.alternateLinkingJobHistory,
                          function (historyItem) {
                            return [
                              _c("tr", { staticClass: "job-history-item" }, [
                                _c("td", { staticClass: "expand-collapse" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "btn btn-sm btn-link",
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleHistoryItem(
                                            historyItem
                                          )
                                        },
                                      },
                                    },
                                    [
                                      !historyItem.expanded
                                        ? _c("font-awesome-icon", {
                                            attrs: { icon: "chevron-down" },
                                          })
                                        : _vm._e(),
                                      historyItem.expanded
                                        ? _c("font-awesome-icon", {
                                            attrs: { icon: "chevron-up" },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]),
                                _c("td", [
                                  _vm._v(_vm._s(historyItem.startedAt)),
                                ]),
                                _c("td", [
                                  _vm._v(_vm._s(historyItem.finishedAt)),
                                ]),
                                _c("td", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        historyItem.isManual
                                          ? _vm.$t("jobHistoryTypeManual")
                                          : _vm.$t("jobHistoryTypeScheduled")
                                      ) +
                                      " "
                                  ),
                                ]),
                                _c("td", [_vm._v(_vm._s(historyItem.status))]),
                                _c("td", { attrs: { colspan: "2" } }, [
                                  _vm._v(" " + _vm._s(historyItem.error) + " "),
                                ]),
                              ]),
                              historyItem.expanded
                                ? [
                                    _vm._l(
                                      historyItem.jobHistoryLogs,
                                      function (log) {
                                        return _c(
                                          "tr",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  historyItem.jobHistoryLogs &&
                                                  historyItem.jobHistoryLogs
                                                    .length,
                                                expression:
                                                  "historyItem.jobHistoryLogs && historyItem.jobHistoryLogs.length",
                                              },
                                            ],
                                          },
                                          [
                                            _c("td", {
                                              staticClass: "expand-collapse",
                                            }),
                                            _c(
                                              "td",
                                              {
                                                staticClass: "py-2",
                                                attrs: { colspan: "6" },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(log.comments) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    !historyItem.jobHistoryLogs ||
                                    !historyItem.jobHistoryLogs.length
                                      ? _c("tr", [
                                          _c("td", {
                                            staticClass: "expand-collapse",
                                          }),
                                          _c(
                                            "td",
                                            {
                                              staticClass: "py-2",
                                              attrs: { colspan: "6" },
                                            },
                                            [_vm._v(" No changes were made. ")]
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]
                                : _vm._e(),
                            ]
                          }
                        ),
                      ],
                      2
                    ),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "row mt-3" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      on: {
                        click: function ($event) {
                          return _vm.runAlternateLinkingJob()
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("runAlternateLinkingJob")) + " "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }